//  services to fetch and patch constraints and weightage

import axios from "axios";
// import { dummyConstraintWeightageData } from "./data";
import { baseUrl } from "../../../../../Redux/App/app.actions";
export const getConstraintsWithWeightageApi = async (setLoading) => {
  try {
    setLoading(true);
    const res = await axios.get(`${baseUrl}/b1/get_constraints`);
    console.log(res);
    const data = res?.data;

    if (data) {
      return data;
    } else {
      console.log("No Data Found");
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const updateConstraintsWithWeightageApi = async (
  payloadAim,
  payloadTarget
) => {
  try {
    const updatedPayload = {
      aim: payloadAim,
      // targetsum: {
      //   Ore: 1000,
      //   Others: 100,
      // },
      ...payloadTarget,
    };
    const res = await axios.post(
      `${baseUrl}/b1/update_constraints`,
      updatedPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(res);
    const data = res?.data;
    if (res.status === 200 && data) {
      return { message: res.data.message, status: true };
    } else {
      console.log("Error while updating data");
    }
  } catch (error) {
    console.log(error);
  }
};
